import React, { useEffect, useState } from 'react';
import Loading from 'react-loading';
import '../../../main.css';



const NotificationsList = ({ typeNotify = 1 }) => { // نوع نوتیفیکیشن به عنوان props
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {                           
        const response = await fetch(`https://api2.raynogroup.com/api/notifications?type_notify=${typeNotify}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setNotifications(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  if (loading) return <Loading type="bars" color="#000" height={50} width={50} />;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="card">
      <div className="card-body">
        <ul className="list-group">
          {notifications.map((notify, index) => (
            <li key={index} className="list-group-item  hover-shadow notification-item">
              <h5 className="mb-2 bg-light title">{notify.title}</h5>
              <p className="mb-1 description smal">{notify.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );

};

export default NotificationsList;